/**
 * DATA
 */

export interface TimelineData {
  date: string;
  label: string;
  value?: number;
  category: string;
  //  tainted is used to mark this piece of data
  //  not reliable and we can add a different style
  tainted?: boolean;
}

/**
 * Timeline data with x y coordinate
 */
export interface TimelineDataWithXY extends TimelineData {
  x: number;
  y: number;
}

/**
 * Interface for key event path data
 * used in gradient.
 */
export interface keyEventPathData {
  date: string;
  x: number;
  y: number;
  value: number;
}

/**
 * DATA POINTS
 */

export interface TimelineDataPoint {
  coordX: number;
  date: string;
  pointsCoordY: Array<number>;
  data: Array<TimelineData>;
}

/**
 * CANVAS
 */

export interface TimelineCanvas {
  width: number;
  height: number;
  margin: TimelineCanvasDirection;
  padding: TimelineCanvasDirection;
}

export interface TimelineCanvasDirection {
  top: number;
  left: number;
  right: number;
  bottom: number;
}

/**
 * CHART LINES
 */

export interface TimelineChartLine {
  data: Array<TimelineData>;
  color: string;
  category: string;
}

/**
 * AXES
 */

export enum TimelineTickType {
  TICK = 'tick',
  SUB_TICK = 'subtick'
}

export interface TimelineAxisTick {
  coord: number;
  label: string;
  size: number;
}

/**
 * Model for key events data
 */
export interface KeyEventData {
  uri: number;
  spaceUri: string;
  tenantUri: string;
  elementUri: string;
  elementTypeUri: string;
  executionDate: number;
  startDate: number;
  endDate: number;
  normalizerCount: number;
  isNotified: boolean;
  isGrowth: boolean;
  growthRate: number;
  signalsCount: number;
  docType: string;

  // These value will be calculated by the timeline.
  x?: number;
  y?: number;
}

/**
 * Model for key events tooltip data.
 */
export interface KeyEventDataTooltip {
  data: KeyEventData;
  position: string;
  elementDOM?: HTMLElement;
}

/**
 * TOOLTIP
 */

export interface TimelineTooltip extends TimelineData {
  position: string;
}

export enum TimelineTooltipAlign {
  LEFT = 'left',
  RIGHT = 'right'
}

/**
 * ANIMATIONS
 */

export enum TimelineAnimationState {
  START = 'start',
  END = 'end'
}

/**
 * STEP
 */
export enum TimelineStep {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year'
}
